import React from 'react';

export interface BrandLogoProps {
  className?: string;
  /** When true, show full site name on sm+ and short name on xs (Navbar/AuthHeader pattern). */
  showText?: boolean;
  imgClassName?: string;
  imgHeight?: number;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  className = '',
  showText = false,
  imgClassName = 'me-2',
  imgHeight = 36,
}) => (
  <span className={`d-inline-flex align-items-center flex-wrap gap-1 ${className}`.trim()}>
    <img
      src="/logo.png"
      alt="SadeceBilgisayar"
      className={imgClassName}
      height={imgHeight}
      style={{ width: 'auto' }}
    />
    <span className="text-primary fw-semibold small text-nowrap" style={{ letterSpacing: '0.01em' }}>
      sadecebilgisayar.com
    </span>
  </span>
);

export default BrandLogo;
